<app-notification-container> </app-notification-container>
<header
  class="fixed w-full top-0 z-50 transition-all duration-300"
  [ngClass]="{
    'py-2 bg-white/90 backdrop-blur-sm shadow-sm': isScrolled,
    'py-5 bg-transparent': !isScrolled
  }"
>
  <div class="container mx-auto px-4 md:px-1 transition-all duration-300"
       [ngClass]="{
         'max-w-5xl': isScrolled,
         'max-w-6xl': !isScrolled
       }">
    <div class="flex items-center justify-between">
      <a routerLink="/" class="flex items-center space-x-2 transition-all duration-300">
        <span class="font-cormorant font-bold text-forest transition-all duration-300"
              [ngClass]="{
                'text-xl md:text-2xl': isScrolled,
                'text-2xl md:text-3xl': !isScrolled
              }">
          <img [src]="logo"
               [width]="(isScrolled || tinyHeader) ? 150 : 200"
               class="transition-all duration-300"/>
        </span>
      </a>

      <!-- Desktop Nav -->
      <nav class="hidden md:flex items-center transition-all duration-300"
           [ngClass]="{
             'space-x-6 text-sm': isScrolled,
             'space-x-8 text-base': !isScrolled
           }">
        <!-- <a (click)="navigateToHome('products')" class="nav-link cursor-pointer">Products</a> -->
        <a  routerLink="/lab-reports" class="nav-link cursor-pointer">Lab Reports</a>
        <a (click)="navigateToHome('benefits')" class="nav-link cursor-pointer">Benefits</a>
        <a (click)="navigateToHome('testimonials')" class="nav-link cursor-pointer">Testimonials</a>
        <a (click)="navigateToHome('contact')" class="nav-link cursor-pointer">Contact</a>
      </nav>

      <!-- User Info + Icons -->
      <div class="hidden md:flex items-center transition-all duration-300"
           [ngClass]="{
             'space-x-3': isScrolled,
             'space-x-4': !isScrolled
           }">
        <span *ngIf="isAuthenticated" class="text-forest font-medium transition-all duration-300"
              [ngClass]="{
                'text-sm': isScrolled,
                'text-base': !isScrolled
              }">
          Hello, {{ userName }}
        </span>

        @if (isAuthenticated) {
          <i-lucide [img]="UserIcon" class="material-icons cursor-pointer" (click)="onProfile()" [size]="isScrolled ? 16 : 18"></i-lucide>
        }
        @else {
          <i-lucide [img]="LoginIcon" class="material-icons cursor-pointer" (click)="onLogin()" title="Login" aria-label="Login" [size]="isScrolled ? 16 : 18"></i-lucide>
        }

        <!-- Icons placeholder -->
        <button aria-label="Cart" class="icon-button px-1 relative cursor-pointer " (click)="navigateToCart()">
          <span class="badge">{{cartCount}}</span>
          <i-lucide [img]="ShoppingCartIcon" class="material-icons" title="Cart" aria-label="Cart" [size]="isScrolled ? 16 : 18"></i-lucide>
        </button>
        <a routerLink="/shop" class="button-primary transition-all duration-300"
           [ngClass]="{
             'text-sm py-1.5 px-3': isScrolled,
             'text-base py-2 px-4': !isScrolled
           }">
          Shop Now
        </a>
      </div>

      <!-- Mobile Menu Toggle -->
      <button aria-label="Menu" class="md:hidden text-forest focus:outline-none" (click)="toggleMobileMenu()">
        <span class="material-icons">
          <span *ngIf="isMobileMenuOpen">
            <i-lucide [img]="ChevronRightIcon"></i-lucide>

          </span>
          <span *ngIf="!isMobileMenuOpen">
            <i-lucide [img]="MenuIcon"></i-lucide>
          </span>
        </span>
      </button>
    </div>
  </div>

  <!-- Mobile Menu (unchanged) -->
  <div
    class="fixed inset-0 bg-white z-40 transform transition-transform duration-300 ease-in-out md:hidden flex flex-col pt-24 px-6"
    [ngClass]="{
      'translate-x-0': isMobileMenuOpen,
      'translate-x-full': !isMobileMenuOpen
    }"
  >
    <nav class="flex flex-col space-y-6 text-center">



      <a (click)="closeMobileMenu()" class="nav-link cursor-pointer"><span-lucide [img]="ChevronRightIcon"></span-lucide></a>

      <div *ngIf="isAuthenticated" class="text-forest font-medium transition-all duration-300"
      [ngClass]="{
        'text-sm': isScrolled,
        'text-base': !isScrolled
      }">
  Hello, {{ userName }}
    </div>

        @if (isAuthenticated) {
          <i-lucide [img]="UserIcon" class="material-icons cursor-pointer" (click)="onProfile()" [size]="isScrolled ? 16 : 18"></i-lucide>
        }
        @else {

          <div >
            <button aria-label="Login" class="icon-button px-1 relative cursor-pointer " (click)="onLogin()">
              <i-lucide [img]="LoginIcon" class="material-icons cursor-pointer" title="Login" aria-label="Login" [size]="isScrolled ? 16 : 18"></i-lucide>
            </button>
            <span class="ml-3">Login</span>
          </div>
        }

      <div >
        <button aria-label="Cart" class="icon-button px-1 relative cursor-pointer " (click)="navigateToCart() ">
          <span class="badge">{{cartCount}}</span>
          <span-lucide [img]="ShoppingCartIcon" class="material-icons" title="Cart" aria-label="Cart" [size]="isScrolled ? 16 : 18"></span-lucide>
        </button>
        <span class="ml-3">Cart</span>
      </div>


      <a  routerLink="/lab-reports" (click)="closeMobileMenu()" class="nav-link cursor-pointer">Lab Reports</a>
      <!-- <a (click)="navigateToHome('products')" class="mobile-nav-link" (click)="closeMobileMenu()">Products</a> -->
      <a (click)="navigateToHome('benefits')" class="mobile-nav-link" (click)="closeMobileMenu()">Benefits</a>
      <a (click)="navigateToHome('testimonials')" class="mobile-nav-link" (click)="closeMobileMenu()">Testimonials</a>
      <a (click)="navigateToHome('contact')" class="mobile-nav-link" (click)="closeMobileMenu()">Contact</a>
      <a routerLink="/shop" class="button-primary mt-6" (click)="closeMobileMenu()">Shop Now</a>
      <span *ngIf="isAuthenticated" class="text-forest mt-4">Logged in as {{ userName }}</span>
    </nav>
  </div>
</header>
